const L = {
  name: "Airplane",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.73 20.1101L9.68 14.7301L9.31 14.7901H3.84L0 7.77006L3.62 6.86006L7.53 9.30006L20.4 6.09006C21.27 5.87006 22.18 6.06006 22.88 6.62006C23.59 7.17006 23.99 8.01006 23.99 8.90006C23.99 10.2301 23.09 11.3901 21.8 11.7101L17.75 12.7201L13.84 18.5801L7.73 20.1101ZM12.85 11.8801L10.89 17.2601L12.6 16.8301L16.51 10.9701L21.31 9.77006C21.71 9.67006 21.99 9.31006 21.99 8.90006C21.99 8.62006 21.86 8.36006 21.65 8.19006C21.43 8.02006 21.15 7.96006 20.88 8.03006L7.18 11.4501L3.27 9.01006L2.98 9.08006L5.01 12.8001H9.18L12.84 11.8801H12.85Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as Airplane
};
